type Query = Record<string, string | string[] | undefined>;

export default function isRockHallTvTemplate(seedNode?: any, query?: Query): boolean {
  // The seed node isn't a page prop on /preview, so fall back to Faust's preview params
  if (query?.preview === 'true') {
    const { typeName, previewPathname } = query;
    if (
      typeName === 'RhtvChannel' ||
      (typeof previewPathname === 'string' && /^\/(?:[a-z]{2}\/)?rrtv\//.test(previewPathname))
    ) {
      return true;
    }
  }

  if (!seedNode) return false;

  return Boolean(
    seedNode && (
      seedNode.template?.templateName === 'Rock Hall TV' ||
      (Array.isArray(seedNode.templates) && seedNode.templates.includes('template-Rock Hall TV')) ||
      seedNode.template?.__typename === 'Template_RockHallTV'
    )
  );
}
